/**
 * Provide a strong-typed version of Object.keys()
 * @param obj The source object
 * @returns Array of keys
 */
export default function getObjectKeys(obj) {
    return Object.keys(obj);
}
//# sourceMappingURL=getObjectKeys.js.map